import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { BookedTrip } from '@ibe/models';
import { Store } from '@ngrx/store';
import * as BookedTripActions from '../../../store/actions/booked-trip.actions';
import * as fromStore from '../../../store';
import { ModalService } from '../../common/modal/modal.indra.service';

@Component({
	selector: 'app-change-flight-modal',
	templateUrl: './change-flight-modal.indra.component.html',
	styleUrls: ['./change-flight-modal.component.scss']
})
export class INDRAChangeFlightModalComponent extends AbstractModalContentComponent implements OnInit {

	constructor(
		protected modalService: ModalService,
		private store: Store<fromStore.State>,
		private router: Router
	) {
		super(modalService);
		this.TYPE = 'dialog';
	}

	ngOnInit() {
	}

	discardExtras() {
		const booking: BookedTrip = this.data[0];
		const callback = this.data[1];

		this.closeModal();

		// Reset all extras
		// booking.resetExtras();
		// this.store.dispatch(new BookedTripActions.PutBookedTripAction(booking));

		callback(false, 'res');
	}

}
